// function mixColorWithWhite(hex, percentage) {
//   const whitePercentage = (100 - percentage) / 100;

//   let r = parseInt(hex?.slice(1, 3), 16);
//   let g = parseInt(hex?.slice(3, 5), 16);
//   let b = parseInt(hex?.slice(5, 7), 16);

//   r = Math.floor(r + (255 - r) * whitePercentage);
//   g = Math.floor(g + (255 - g) * whitePercentage);
//   b = Math.floor(b + (255 - b) * whitePercentage);

//   return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
// }

export const photoName = (nameOne, nameTwo) => {
  const name = nameOne || nameTwo;
  return name?.length > 35 ? name.slice(0, 32) + "..." : name;
};

export const PagePhotoUploadTitle = ({ pageIcon, pageName }) => (
  <span
    className="d-inline-flex align-items-center"
    style={{ gap: 4, minWidth: 0, maxWidth: "100%", verticalAlign: "middle" }}
  >
    <span style={{ flexShrink: 0 }}>Upload to </span>
    <img src={pageIcon} alt="" width={15} height={15} style={{ flexShrink: 0 }} />
    <span className="text-truncate">and {pageName} Page</span>
  </span>
);

export const BrokenPreviewImage = () => {
  return (
    <svg height={60} width={60} viewBox="0 0 64 64" enableBackground="new 0 0 64 64" fill="#000000">
      <g strokeWidth="0" />
      <g strokeLinecap="round" strokeLinejoin="round" />
      <g>
        <g>
          <polygon
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeMiterlimit="10"
            points="23,1 55,1 55,63 9,63 9,15 "
          />
          <polyline
            fill="none"
            stroke="#000000"
            strokeWidth="2"
            strokeMiterlimit="10"
            points="9,15 23,15 23,1 "
          />
        </g>
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          strokeMiterlimit="10"
          cx="32"
          cy="36"
          r="9"
        />
        <line
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          strokeMiterlimit="10"
          x1="25.834"
          y1="29.834"
          x2="38.166"
          y2="42.166"
        />
      </g>
    </svg>
  );
};

export const PhotoViewCard = ({
  photo,
  slot,
  handleDocPreview,
  modifiedView,
  cardWidth = 255,
  rowIndex,
  cardPositionInRow,
}) => {
  const getCardBackground = () => {
    const isEvenRow = rowIndex % 2 === 0;
    const isEvenPosition = cardPositionInRow % 2 === 0;

    if (isEvenRow) {
      return isEvenPosition ? "var(--primary-4)" : "var(--primary-2)";
    }
    return isEvenPosition ? "var(--primary-2)" : "var(--primary-4)";
  };

  const cardWidthPx = `${cardWidth}px`;
  const imgWidth = cardWidth - 10;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      {/* {photo?.for_page === 8 && (
        <div
          className="has-primary-font-detail-view-card"
          style={{
            display: "flex",
            justifyContent: photo?.panelName === null ? "center" : "flex-start",
            alignItems: "center",
            background: photo?.specialty?.color
              ? mixColorWithWhite(photo?.specialty?.color, 10)
              : "var(--primary-15)",
            color: "var(--primary)",
            width: cardWidthPx,
            minWidth: cardWidthPx,
            maxWidth: cardWidthPx,
            fontSize: "14px",
            fontWeight: "600",
            height: "25px",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {photo?.panelName !== null && (
            <>
              <span
                className="d-flex m-r-5 align-items-center justify-content-center"
                style={{
                  width: "25px",
                  height: "25px",
                  background: photo?.specialty?.color || "#000",
                  color: "white",
                  minWidth: "25px",
                }}
              >
                {photo?.specialty?.name?.[0] || "?"}
              </span>
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "14px",
                  fontWeight: "600",
                  height: "25px",
                  textTransform: "uppercase",
                  alignContent: "center",
                }}
              >
                {photo.panelName}
              </span>
            </>
          )}

          {photo?.panelName === null && (
            <span
              className="m-l-2"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "14px",
                fontWeight: "600",
                height: "25px",
                textTransform: "uppercase",
                alignContent: "center",
              }}
            >
              {slot?.slot_number === 0
                ? `Attached to ${slot?.page?.name} Page`
                : slot?.slot_name}
            </span>
          )}
        </div>
      )}

      {photo?.for_page !== 8 && (
        <div
          className="has-primary-font-detail-view-card"
          style={{
            display: slot?.slot_number !== 0 && "flex",
            justifyContent: slot?.slot_number !== 0 && "center",
            alignItems: slot?.slot_number !== 0 && "center",
            padding: "0px 10px",
            background: "var(--primary-15)",
            color: "var(--primary)",
            width: cardWidthPx,
            minWidth: cardWidthPx,
            maxWidth: cardWidthPx,
            fontSize: "14px",
            fontWeight: "600",
            height: "25px",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            alignContent: slot?.slot_number === 0 && "center",
          }}
        >
          {photo?.for_page
            ? slot?.slot_number === 0
              ? `Attached to ${slot?.page?.name} Page`
              : photo?.panelName ||
                (slot?.slot_name === null && "Available") ||
                slot?.slot_name ||
                "Unattached Photo"
            : "Unattached Photo"}
        </div>
      )} */}

      <div
        className={`font-weight-semibold p-0 cursor-pointer detailed-empty-card border-0 ${modifiedView && " "}`}
        id="no-vertical-border"
        onClick={() => handleDocPreview(photo)}
        key={photo.id}
        style={{
          width: cardWidthPx,
          minWidth: cardWidthPx,
          maxWidth: cardWidthPx,
          background: getCardBackground(),
        }}
      >
        {/* <div
          title={photo.title || slot?.slot_name}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "0 5px",
          }}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              className="ic ic-19 cursor-pointer img-19px"
              alt=""
            />
          </span>
          <p className="name new-view-title p-0" style={{ alignContent: "center" }}>
            {slot?.slot_number === 0 ? "" : slot === null ? "" : `${slot?.slot_number} .`}{" "}
            {photoName(photo?.title, slot?.slot_name)}
          </p>
        </div> */}

        <div
          id={`${photo.id}-${photo.title || slot?.slot_name}`}
          className="detailed-empty-card-img-div"
          style={{
            height: "297px",
          }}
        >
          {photo?.image ? (
            <img
              src={photo.image}
              alt={photo.title || ""}
              style={{ height: 287, width: imgWidth, objectFit: "contain" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : (
            <BrokenPreviewImage />
          )}
        </div>
      </div>
    </div>
  );
};
